import React from "react";
import { Container, Text } from "@jds/core";
import { Box, Button as MuiButton } from "@mui/material";

const reminderStateLabel = {
  ELIGIBLE: "Eligible",
  CLICKED_TODAY: "Clicked today",
  LIMIT_REACHED: "Limit reached",
};

const reminderStateMessage = {
  ELIGIBLE: "Request the guest to upload a profile picture.",
  CLICKED_TODAY: "Reminder already sent today.",
  LIMIT_REACHED: "Reminder already sent. Maximum reminder limit reached.",
};

const reminderStateTone = {
  ELIGIBLE: {
    label: "Ready to send",
    backgroundColor: "rgba(12, 102, 228, 0.10)",
    color: "var(--color-primary-60)",
  },
  CLICKED_TODAY: {
    label: "Sent today",
    // backgroundColor: "rgba(245, 158, 11, 0.14)",
    // color: "#B45309",
    backgroundColor: "var(--color-sparkle-30)",
    color: "var(--color-sparkle-80)",
  },
  LIMIT_REACHED: {
    label: "Limit reached",
    backgroundColor: "rgba(15, 23, 42, 0.08)",
    color: "var(--color-primary-grey-80)",
  },
};

const GuestProfileReminderCTA = ({
  reminderCtaState,
  onClick = () => { },
  isLoading = false,
  forceDisabled = false,
}) => {
  if (!reminderCtaState || reminderCtaState === "HIDDEN") {
    return null;
  }

  const isDisabled =
    forceDisabled ||
    reminderCtaState === "CLICKED_TODAY" ||
    reminderCtaState === "LIMIT_REACHED" ||
    isLoading;
  const stateTone = reminderStateTone[reminderCtaState];

  return (
    <Container
      direction="column"
      gap={8}
      fullWidth
      style={{
        marginTop: "16px",
        padding: "16px",
        borderRadius: "24px",
        background:
          "linear-gradient(180deg, rgba(245,247,250,0.95) 0%, rgba(238,242,246,0.95) 100%)",
        border: "1px solid rgba(15, 23, 42, 0.08)",
      }}
    >
      <Text
        text="Profile Picture Reminder"
        appearance="body-s-bold"
        color="primary_grey_100"
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 0.75,
        }}
      >
        <Box>
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              minHeight: "24px",
              px: 1.25,
              mb: 1,
              borderRadius: "999px",
              backgroundColor: stateTone?.backgroundColor,
              '& .text-atom': {
                color: stateTone?.color,
                // fontWeight: 700
              }
            }}
          >
            <Text
              text={stateTone?.label || reminderStateLabel[reminderCtaState] || reminderCtaState}
              appearance="body-xs-bold"
              style={{ color: stateTone?.color, fontWeight: 700 }}
            />
          </Box>
        </Box>
        <Text
          text={reminderStateMessage[reminderCtaState] || ""}
          appearance="body-xs"
          color="primary_grey_80"
        />
      </Box>
      <Box sx={{ marginTop: "8px", width: "100%" }}>
        <MuiButton
          fullWidth
          variant="outlined"
          disabled={isDisabled}
          onClick={onClick}
          sx={{
            minHeight: "40px",
            borderRadius: "16px",
            borderColor: "var(--color-primary-50)",
            color: "var(--color-primary-50)",
            backgroundColor: "#fff",
            textTransform: "none",
            fontFamily: "var(--font-families-body-s)",
            fontSize: "var(--font-sizes-body-s)",
            fontWeight: "var(--font-weights-body-s-bold, 700)",
            lineHeight: "var(--line-heights-body-s)",
            boxShadow: "none",
            "&:hover": {
              borderColor: "var(--color-primary-60)",
              backgroundColor: "rgba(12, 102, 228, 0.06)",
              boxShadow: "none",
            },
            "&.Mui-disabled": {
              borderColor: "rgba(15, 23, 42, 0.12)",
              color: "rgba(15, 23, 42, 0.38)",
              backgroundColor: "rgba(15, 23, 42, 0.04)",
            },
          }}
        >
          {isLoading
            ? "Sending..."
            : reminderCtaState === "LIMIT_REACHED"
              ? "Reminder already sent"
              : "Request profile picture"}
        </MuiButton>
      </Box>
    </Container>
  );
};

export default React.memo(GuestProfileReminderCTA);
